/**
 * @generated SignedSource<<e2f6624a1d7073e08847b0068af069c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageType = "MEMBERSHIP" | "STANDARD";
export type MembershipDetailScreenQuery$variables = {
  membershipId: string;
  packageType: PackageType;
};
export type MembershipDetailScreenQuery$data = {
  readonly membership: {
    readonly package?: {
      readonly " $fragmentSpreads": FragmentRefs<"usePackageDisplayName_package">;
    };
    readonly " $fragmentSpreads": FragmentRefs<"PackageDetail_memberPackage">;
  } | null | undefined;
};
export type MembershipDetailScreenQuery = {
  response: MembershipDetailScreenQuery$data;
  variables: MembershipDetailScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "membershipId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "packageType"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "membershipId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MembershipDetailScreenQuery",
    "selections": [
      {
        "alias": "membership",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PackageDetail_memberPackage"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "usePackageDisplayName_package"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MembershipDetailScreenQuery",
    "selections": [
      {
        "alias": "membership",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "package",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isPackage"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "DisplayInApp",
                    "kind": "LinkedField",
                    "name": "displayInApp",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "displayName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BenefitsSummaryLine",
                    "kind": "LinkedField",
                    "name": "benefitsSummary",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "billingType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BillingOption",
                    "kind": "LinkedField",
                    "name": "billingOptions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingCharge",
                        "kind": "LinkedField",
                        "name": "billingCharges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "frequency",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SquareItemVariation",
                            "kind": "LinkedField",
                            "name": "squareVariation",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "amount",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cancelledOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endsOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Customer",
                "kind": "LinkedField",
                "name": "customer",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "packageType",
                            "variableName": "packageType"
                          },
                          {
                            "kind": "Literal",
                            "name": "saleAvailability",
                            "value": "PUBLIC"
                          }
                        ],
                        "concreteType": "PackageConnection",
                        "kind": "LinkedField",
                        "name": "packages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "count",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderConnection",
                "kind": "LinkedField",
                "name": "orders",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrderEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Order",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "packageDueDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isPaid",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SquareCardOnFile",
                "kind": "LinkedField",
                "name": "squareCard",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cardBrand",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastFour",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expMonth",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "expYear",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "MemberPackage",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51f182e45570b709b42b3246af53b353",
    "id": null,
    "metadata": {},
    "name": "MembershipDetailScreenQuery",
    "operationKind": "query",
    "text": "query MembershipDetailScreenQuery(\n  $membershipId: ID!\n  $packageType: PackageType!\n) {\n  membership: node(id: $membershipId) {\n    __typename\n    ...PackageDetail_memberPackage\n    ... on MemberPackage {\n      package {\n        __typename\n        ...usePackageDisplayName_package\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment CancelPackageModal_memberPackage on MemberPackage {\n  id\n  package {\n    __typename\n    ...usePackageDisplayName_package\n    ...PackageBenefitsSummary_package\n    benefitsSummary {\n      description\n    }\n    id\n  }\n}\n\nfragment CanceledPackageBanner_memberPackage on MemberPackage {\n  id\n  cancelledOn\n  endsOn\n}\n\nfragment PackageBenefitsSummary_package on Package {\n  __isPackage: __typename\n  benefitsSummary {\n    description\n  }\n}\n\nfragment PackageDetailActions_memberPackage on MemberPackage {\n  ...CancelPackageModal_memberPackage\n  ...useShouldShowCancelButton_memberPackage\n  id\n  customer {\n    id\n    club {\n      ...useClubIsSellingPackages_club\n      id\n    }\n  }\n  package {\n    __typename\n    name\n    id\n  }\n}\n\nfragment PackageDetailBilling_memberPackage on MemberPackage {\n  id\n  ...useGetOutstandingOrders_memberPackage\n  ...useGetPriceMap_memberPackage\n  ...useGetBillingPeriod_memberPackage\n  ...useGetNextPaymentDate_memberPackage\n  ...CanceledPackageBanner_memberPackage\n  package {\n    __typename\n    id\n  }\n  cancelledOn\n  squareCard {\n    cardBrand\n    lastFour\n    expMonth\n    expYear\n    id\n  }\n}\n\nfragment PackageDetail_memberPackage on MemberPackage {\n  id\n  ...PackageDetailActions_memberPackage\n  ...PackageDetailBilling_memberPackage\n  package {\n    __typename\n    ...PackageBenefitsSummary_package\n    id\n  }\n}\n\nfragment packageOrderNeedsPayment_order on Order {\n  status\n  packageDueDate\n}\n\nfragment useClubIsSellingPackages_club on Club {\n  packages(packageType: $packageType, saleAvailability: PUBLIC) {\n    count\n  }\n}\n\nfragment useGetBillingPeriod_memberPackage on MemberPackage {\n  id\n  package {\n    __typename\n    billingType\n    id\n  }\n}\n\nfragment useGetNextPaymentDate_memberPackage on MemberPackage {\n  orders {\n    edges {\n      node {\n        isPaid\n        packageDueDate\n        id\n      }\n    }\n  }\n}\n\nfragment useGetOutstandingOrders_memberPackage on MemberPackage {\n  orders {\n    edges {\n      node {\n        id\n        ...packageOrderNeedsPayment_order\n      }\n    }\n  }\n}\n\nfragment useGetPriceMap_memberPackage on MemberPackage {\n  package {\n    __typename\n    billingOptions {\n      billingCharges {\n        frequency\n        squareVariation {\n          amount\n          id\n        }\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment usePackageDisplayName_package on Package {\n  __isPackage: __typename\n  displayInApp {\n    displayName\n  }\n  name\n}\n\nfragment useShouldShowCancelButton_memberPackage on MemberPackage {\n  cancelledOn\n  endsOn\n  package {\n    __typename\n    billingType\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "50cb02ee275071370a67f9122db9048b";

export default node;
